import { untrack } from "svelte";
import { commitPopPush, stack } from "../stack/global.svelte";
import { sheetClose, sheetGoBack, sheetOpenById } from "../apis/methods.js";
import { stackScope } from "../stack/stack.utils";

const log = /*           */ stackScope.scope("instance");

export interface OcSheetV1InstanceState {
  /**
 *
 *
 */
  isCurrent: boolean;
  /**
 *
 *
 *
 */
  isActive: boolean;
  /**
 *
 *
 *
 *
 *
 *
 */
  isVisible: boolean;
  /**
 *
 *
 */
  isShown: boolean;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const useSheetStack = (init: {
  id: () => string;
  open: () => boolean | undefined;
  activation: (isActive: boolean) => void;
}): OcSheetV1InstanceState => {
  const state = $state<OcSheetV1InstanceState>({
    isCurrent: false,
    isActive: false,
    isVisible: false,
    isShown: false,
  });

  /*                                                         */
  $effect(() => {
    const sheetId = init.id();
    const wantsOpen = init.open();
    const isActive = untrack(() => state.isCurrent);

    /*                                               */
    if (wantsOpen === isActive)
      return log.debug("Instance already in wants open state", sheetId, wantsOpen);

    if (wantsOpen) {
      log.info("open instance", sheetId);
      sheetOpenById(sheetId);
    } else if (untrack(() => stack.contentChange)) {
      log.info("pop instance", sheetId);
      sheetGoBack();
    } else {
      log.info("close instance", sheetId);
      sheetClose();
    }
  });

  /*                                                                       */
  /*                                                         */
  $effect(() => {
    const sheetId = init.id();
    const isCurrent = stack.current === init.id();

    /*                                                                       */
    /*                                                                               */
    if (isCurrent === state.isCurrent)
      return log.debug("Instance already in is current state", sheetId, isCurrent);

    state.isCurrent = isCurrent;

    /*                                             */

    log.scope("syncronizer").info("Instance isCurrent changed", sheetId, isCurrent);

    init.activation(isCurrent);

    const isActive = untrack(() => state.isActive);
    const isShown = untrack(() => state.isShown);

    if (isCurrent && !isActive) {
      state.isActive = true;
    } else if (!isCurrent && isShown) {
      state.isShown = false;
    }
  });

  /*                                                                   */
  $effect(() => {
    const isCurrent = untrack(() => state.isCurrent);
    const { isShown, isActive } = state;

    setTimeout(() => {
      if (isCurrent && isShown) commitPopPush();
      if (!isCurrent && !isActive) commitPopPush();
    }, 0);
  });

  return state;
};
